import { css } from '@emotion/react';
import styled from '@emotion/styled';

const TrustWrapper = styled.div<{
  isPlainTemplate?: boolean;
  hasStageAbove?: boolean;
}>`
  display: none;
  flex-direction: column;
  gap: 1rem;
  position: absolute;
  bottom: calc(100% - 30px);
  right: 0;
  max-width: 285px;

  ${({ theme, isPlainTemplate, hasStageAbove }) =>
    isPlainTemplate && hasStageAbove
      ? css`
          ${theme.mq('lg')} {
            display: block;
          }
        `
      : css`
          ${theme.mq('sm')} {
            display: block;
          }
        `}

  ${({ theme }) => theme.mq('md')} {
    right: 50%;
    transform: translateX(50%);
  }

  ${({ theme }) => theme.mq('xl')} {
    display: flex;
    position: static;
    bottom: auto;
    right: auto;
    transform: none;
  }
`;

const TrustElement = styled.div<{ isHighlighted?: boolean }>`
  padding: ${({ theme }) => theme.spacing[40]};
  border-radius: ${({ theme }) => theme.radius.md};
  border: ${({ theme, isHighlighted }) =>
    isHighlighted ? '' : `1px solid ${theme.colors.neutral.grey40}`};
  color: ${({ theme, isHighlighted }) =>
    isHighlighted
      ? theme.colors.neutral.white100
      : theme.colors.neutral.grey160};
  background-color: ${({ theme, isHighlighted }) =>
    isHighlighted
      ? theme.colors.brand.green100
      : theme.colors.neutral.white100};
`;

export { TrustWrapper, TrustElement };
